import { IdAndNameOf } from './IApiBaseResource';
import { IApiProfileBase } from './IApiProfileBase';
import { IApiLp } from './IApiLp';

export enum ApiPricingMode {
  EXCHANGE = 'EXCHANGE',
  FAILOVER = 'FAILOVER',
  BASIC_AGGREGATION = 'BASIC_AGGREGATION',
}

export enum ApiAggregationMethod {
  SUM_VOLUMES = 'SUM_VOLUMES',
  SEPARATE_LP = 'SEPARATE_LP',
}

export interface IApiPricingProfile extends IApiProfileBase {
  mode: ApiPricingMode;
  aggregationMethod?: ApiAggregationMethod;
  lps: IdAndNameOf<IApiLp>[];
}

export interface IApiPricingProfileUpdate {
  id?: IApiPricingProfile['id'];
  name: string;
  mode: IApiPricingProfile['mode'];
  aggregationMethod?: IApiPricingProfile['aggregationMethod'];
  lps: number[];
}
